import { mutatorAction } from 'satcheljs';
import getDefaultCLPLabel from 'owa-mail-clp/lib/utils/getDefaultCLPLabel';
import ItemCLPInfo from 'owa-mail-store/lib/store/schema/ItemCLPInfo';
import { ComposeViewState } from 'owa-mail-compose-store';

export default mutatorAction(
    'updateCLPViewState',
    (viewState: ComposeViewState, itemCLPInfo: ItemCLPInfo) => {
        if (viewState) {
            const { clpViewState } = viewState;
            const { selectedLabel, nonTenantLabelString } = itemCLPInfo;
            if (selectedLabel) {
                clpViewState.selectedCLPLabel = selectedLabel;
                clpViewState.originalCLPLabel = selectedLabel;
            }
            if (!clpViewState.selectedCLPLabel) {
                clpViewState.selectedCLPLabel = getDefaultCLPLabel();
            }
            clpViewState.nonTenantLabelString = nonTenantLabelString;
        }
    }
);
